import React, { Component } from "react";
import { connect } from "react-redux";
import styles from "./DashboardPage.module.css";

export class DashboardPage extends Component {
  setClientKey(event) {
    const accountId = event.currentTarget.value;
    window.location = `/clients/${accountId}`;
  }

  renderClient(client) {
    return (
      <option value={client.id} key={client.id}>
        {client.name}
      </option>
    );
  }

  render() {
    const { clients } = this.props;

    if (!clients) {
      return <div>Loading</div>;
    }

    if (clients.length === 0) {
      return (
        <div className={styles.container}>
          <h1>Your user has access to no clients</h1>
          <p>Please contact your account creator to request access</p>
        </div>
      );
    }

    if (clients.length === 1) {
      window.location = `/clients/${clients[0].id}`;

      return <div />;
    }

    return (
      <div className={styles.container}>
        <h1>Your user has access to multiple clients</h1>
        <p>Choose the client you wish to access</p>
        <select onChange={this.setClientKey}>
          <option value="">Please select client</option>
          {clients.map(this.renderClient)}
        </select>
      </div>
    );
  }
}

// Connect state data
function mapStateToProps(state) {
  const { identity } = state.auth;
  const user = identity.name;
  const clients = identity.access;

  return {
    user,
    clients,
  };
}

// Connect actions
export default connect(mapStateToProps, {})(DashboardPage);
